import React from 'react';
import useDotLottie from '../../../commons/hooks/useDotLottie';

import CommonImages from '../../../commons/images';

const SpinnerAnimation = CommonImages.LOADING_CONNECTOR_LOTTIE;

const SpinnerLottie = ({ ...props }) => {
    const { canvasRef } = useDotLottie({ src: SpinnerAnimation });

    return <canvas ref={canvasRef} aria-label="spinner" style={{ width: 200, height: 100 }} {...props} />;
};

export default SpinnerLottie;
